/**
 * Adzuki
 * cpcentral_notifications.js
 */

(function CpcentralNotifications($, Adzuki)
{
	"use strict";

	var CpcentralNotifications;
	var alertFadeOut = 5000;
	var myTimeout;
	var filteredCategories = [];

	// this is the handler that accepts the data via eventnotify
	CpcentralNotifications = function CpcentralNotifications() {
		this.cpmaxxEventHandler = function cpmaxxEventHandler(eventData) {
			// HANDY FOR DEBUGGING
			// console.log(eventData);
			switch (eventData.eventType) {
				case 'new_notification':
					console.log("Received new notification message");

					if (parseFloat(eventData.unread) > 0) {
						$('.notification-icon').addClass('nav-badge');
						$('.notification-icon').attr('data-amount', parseFloat(eventData.unread));

						document.getElementById('cpcentral-notification-sound').play();

						Adzuki.TitleAlert('New notification arrived');
					} else {
						$('.notification-icon').removeClass('nav-badge');
						$('.notification-icon').attr('data-amount', 0);
					}

					if ($('.cpcentral-notification').is(":visible")) {
						loadCpCentralNotifications(false);
					} else {
						loadCpCentralNotificationAlert();
					}
				break;
				default:
					console.log('Should really never get here');
				break;
			}
		};

		return;
	};

	$(document).ready(function documentReady()
	{
		Adzuki.CpcentralNotifications = new CpcentralNotifications();

		// show/hide the main UI for the notifications
		$(".cpcentral-notification-link a").click(function cpCentralNotificationsShowHide(e) {
			e.preventDefault();

			if ($('.cpcentral-notification').is(":visible")) {
				$('.cpcentral-notification').hide();
			} else {
				$('#cpcentral-notification').removeClass('nav-badge');
				loadCpCentralNotifications(true);
			}
		});

		// hide the notification UI
		$('#cpcentral-notification-container').on('click', '.cpcentral-notification-close', function hideCpCentralNotification() {
			$('.cpcentral-notification').hide();
		});

		// this will mark all records for the agent as deleted
		$('#cpcentral-notification-container').on('click', '.cpcentral-notification-clear-all', function removeAllNotification(e) {
			e.preventDefault();

			Adzuki.CustomConfirm({
				title  : 'Decision Time',
				content: 'Are you sure you want to remove all notifications?',
				confirm: function confirm() {
					Adzuki.Ajax.get('/CpcentralNotifications/removeAll/').then(function success(data) {
						loadCpCentralNotifications(true);
					});
				}
			});
		});

		// captures click from "toaster" popup
		$('#cpcentral-notification-container').on('click', '.cpcentral-notification-link', function showEm(e) {
			e.preventDefault();
			clearTimeout(myTimeout);
			loadCpCentralNotifications(true);
		});

		// marks an individual notification as deleted
		$('#cpcentral-notification-container').on('click', '.remove-notification', function removeNotification(e) {
			var notification_id = $(this).data('id');
			e.preventDefault();

			Adzuki.CustomConfirm({
				title  : 'Decision Time',
				content: 'Are you sure you want to remove this notification?',
				confirm: function confirm() {
					Adzuki.Ajax.get('/CpcentralNotifications/remove/' + notification_id).then(function success(data) {
						loadCpCentralNotifications(true);
					});
				}
			});
		});

		// marks a notification that was seen as unseen
		$('#cpcentral-notification-container').on('click', '.mark-unseen-notification', function markAsUnseen(e) {
			var notification_id = $(this).data('id');

			e.preventDefault();

			$(this).addClass('hidden');
			$('#change-notification-loader[data-id="' + notification_id +'"]').removeClass('hidden');

			Adzuki.Ajax.get('/CpcentralNotifications/markAsUnseen/' + notification_id).then(function success(data) {
				loadCpCentralNotifications(true);

				if (data.badge_count <= 0) {
					$('.notification-icon').removeClass('nav-badge');
				} else {
					$('.notification-icon').attr('data-amount', data.badge_count);
				}

			}).done(function afterMarkedUnseen() {
				$(this).removeClass('hidden');
				$('#change-notification-loader[data-id="' + notification_id +'"]').removeClass('hidden');
			});
		});

		// marks a notification that was unseen as seen
		$('#cpcentral-notification-container').on('click', '.mark-seen-notification', function markAsSeen(e) {
			var notification_id = $(this).data('id');
			var link            = $(this).data('link');
			var target          = $(this).data('target');

			e.preventDefault();

			$(this).addClass('hidden');
			$('#change-notification-loader[data-id="' + notification_id +'"]').removeClass('hidden');

			Adzuki.Ajax.get('/CpcentralNotifications/markAsSeen/' + notification_id).then(function success(data) {
				loadCpCentralNotifications(true);

				if (data.badge_count <= 0) {
					$('.notification-icon').removeClass('nav-badge');
				} else {
					$('.notification-icon').attr('data-amount', data.badge_count);
				}

			}).done(function afterMarkedSeen() {
				$(this).removeClass('hidden');
				$('#change-notification-loader[data-id="' + notification_id +'"]').removeClass('hidden');
				if (typeof link !== 'undefined') {
					if (link.indexOf('http') === 0 || link.indexOf('https') === 0) {
						window.open(link, target);
					} else {
						window.open(Adzuki.base_uri + link, target);
					}
					//	window.open('http://' + link, target); 
				}
			});
		});

		// executes a search from the button -- DEPRECATED
		$('#cpcentral-notification-container').on('click', '#cpcentral-notification-filter-button', function doSearch(e) {
			var term = $('#cpcentral-notification-filter').val();

			cpCentralNotificationsSearch(term);
		});

		// executes a search when the enter key is pressed
		$('#cpcentral-notification-container').on('keypress', '#cpcentral-notification-filter', function enterPressed(e) {
			var term = $('#cpcentral-notification-filter').val();

			if (e.keyCode === 13) {
				cpCentralNotificationsSearch(term);
			}
		});

		// clears the search criteria and reloads all notifications
		$('#cpcentral-notification-container').on('click', '.cpcentral-notification-clear-search', function clearSearch(e) {
			e.preventDefault();
			$('#cpcentral-notification-filter').val('');
			loadCpCentralNotifications(true);
		});

		// clears the search criteria out of the text field
		$('#cpcentral-notification-container').on('click', '.cpcentral-notification-clear-search-button', function clearSearchButton(e) {
			e.preventDefault();
			$('#cpcentral-notification-filter').val('');
			loadCpCentralNotifications(true);
		});

		// toggles the DNB - same thing as changing the setting inside the My Settings area
		$('#cpcentral-notification-container').on('click', '#cpcentral-notification-dnb-toggle', function toggleDnd(e) {
			Adzuki.Ajax.get('/CpcentralNotifications/toggleInstantNotifications/' + $(this).prop('checked'))
			.then(function success(data) {
				console.log('toggled');
			});
		});

		// filters the notifcation by the categories
		$('#cpcentral-notification-container').on('click', '.cpcentral-notification-category', function toggleCategories() {
			var category_index,
				category            = $(this).data('category'),
				cookie_categories   = Cookies.get('filtered-categories');

			if (cookie_categories !== undefined && cookie_categories.length > 0) {
				filteredCategories = JSON.parse(cookie_categories);
			}

			if ($(this).hasClass('cpcentral-notification-category-active')) {
				$(this).children('img').attr('src', Adzuki.base_uri + '/images/icons/notifications/' + category + '-disabled.png');

				$(this).removeClass('cpcentral-notification-category-active');
				$(this).addClass('cpcentral-notification-category-disabled');

				filteredCategories.push(category);
				showHideCategories(category, 'hide');
			} else {
				$(this).children('img').attr('src', Adzuki.base_uri + '/images/icons/notifications/' + category + '.png');
				$(this).attr('data-status', 'active');

				$(this).removeClass('cpcentral-notification-category-disabled');
				$(this).addClass('cpcentral-notification-category-active');

				category_index = filteredCategories.indexOf(category);

				if (category_index !== -1) {
					filteredCategories.splice(category_index, 1);
				}

				showHideCategories(category, 'show');
			}

			Cookies.set('filtered-categories', JSON.stringify(filteredCategories));
		});

		// shows or hides the category filter once the link is clicked
		$('#cpcentral-notification-container').on('click', '.cpcentral-notification-category-hide-link', function hideBox(e) {
			e.preventDefault();

			if ($(this).html() === 'Show Filters') {
				$('.cpcentral-notification-category-filters').removeClass('hidden');
				$(this).html('Hide Filters');

				Cookies.set('hide-cpcentral-categories', 0);
			} else {
				$('.cpcentral-notification-category-filters').addClass('hidden');
				$(this).html('Show Filters');

				Cookies.set('hide-cpcentral-categories', 1);
			}
		});

		// displays a mail message in a modal
		$('#cpcentral-notification-container, #cpcentral-notification-list').on('click', '.email-view-button', function showEmailMessage(e) {
			var notification_id = $(this).data('notification-id'),
				modal           = $('.modal');

			e.preventDefault();

			modal.find('.modal-body').text('Loading message...');
			modal.find('.modal-body').html('<iframe src="' + Adzuki.base_uri + '/CpcentralNotifications/message/' + notification_id + '" style="border:none; width: 100%; height: 500px;"></iframe>');

			modal.find('.modal-title').text('Message Details');
			modal.on('hidden.bs.modal', function _restoreModal() {
				modal.removeClass('wide').off('hidden.bs.modal');
			}).modal('show');
		});
	});

	function cpCentralNotificationsSearch(term)
	{
		if (term.length > 3) {
			Adzuki.Ajax.get('/CpcentralNotifications/get/1/' + term)
			.then(function success(data) {
				$('#cpcentral-notification-container').html(data);
				$('.cpcentral-notification').show();

				setBadges();
			});
		} else {
			Adzuki.Ajax.get('/CpcentralNotifications/get/1')
			.then(function success(data) {
				$('#cpcentral-notification-container').html(data);
				$('.cpcentral-notification').show();

				setBadges();
			});
		}
	}

	function loadCpCentralNotifications(markSeen)
	{
		if ($('#cpcentral-notification-container').length > 0) {
			Adzuki.Ajax.get('/CpcentralNotifications/get/'+ markSeen)
			.then(function success(data) {
				$('#cpcentral-notification-container').html(data);
				$('.cpcentral-notification').show();

				if (markSeen !== false) {
					// update the badge
					$('.notification-icon').attr('data-amount', $('.cpcentral-notification-badge-count').val());
					if (!$('.notification-icon').hasClass('nav-badge') && $('.cpcentral-notification-badge-count').val() !== '0') {
						$('.notification-icon').addClass('nav-badge');
					} else if ($('.cpcentral-notification-badge-count').val() <= '0') {
						$('.notification-icon').removeClass('nav-badge');
					}
				}

				setBadges();
			});
		} else {
			Adzuki.StatusMessage('error', 'This feature is not available within the Home Office App.', 'Not available');
		}
	}

	function loadCpCentralNotificationAlert()
	{
		Adzuki.Ajax.get('/CpcentralNotifications/alert/')
		.then(function success(data) {
			$('#cpcentral-notification-container').html(data);
			$('.cpcentral-notification').show();
		});

		myTimeout = setTimeout(
			function closeIt() {
				$('#cpcentral-notification-container').html('');
				$('.cpcentral-notification').fadeOut();
			},
			alertFadeOut
		);
	}

	function setBadges()
	{
		var category,
			count = 0,
			filtered_categories,
			filtered_array,
			category_index;

		filtered_categories = Cookies.get('filtered-categories');

		if (filtered_categories !== undefined && filtered_categories.length > 0) {
			filtered_array = JSON.parse(filtered_categories);
		}

		$('.cpcentral-notification-category-badge').each(function setEm() {
			category = $(this).data('category');

			if (filtered_categories !== undefined && filtered_categories.length > 0) {
				category_index = filtered_array.indexOf(category);

				$('.cpcentral-notification-item').each(function getItem() {
					if ($(this).data('category') === category && category_index === -1) {
						count++;
					}
				});
			} else {
				$('.cpcentral-notification-item').each(function getItem() {
					if ($(this).data('category') === category) {
						count++;
					}
				});
			}

			if (count > 0) {
				$(this).removeClass('hidden');
				$(this).html(parseFloat(count));
				count = 0;
			}
		});
	}

	function showHideCategories($category, $show_hide)
	{
		var new_count = 0;
		$('.cpcentral-notification-item').each(function showEmOrNot() {
			if ($(this).data('category') === $category && $show_hide === 'show') {
				$(this).removeClass('hidden');

				$('.cpcentral-notification-category-badge').each(function showadge() {
					if ($category === $(this).data('category')) {
						$(this).removeClass('hidden');

						if ($(this).html() === '') {
							$('.cpcentral-notification-item').each(function getItem() {
								if ($(this).data('category') === $category) {
									new_count++;
								}
							});

							$(this).html(parseFloat(new_count));
						}
					}
				});
			} else if ($(this).data('category') === $category && $show_hide === 'hide') {
				$(this).addClass('hidden');

				$('.cpcentral-notification-category-badge').each(function hideBadge() {
					if ($category === $(this).data('category')) {
						$(this).addClass('hidden');
					}
				});
			}
		});
	}
}(jQuery, window.Adzuki || {}));